export default "__VITE_ASSET__BLDO5LiJ__"